import type { ProjectEntity, ProjectMutateVariables } from "./project.type";
import type { UseCreateOptions, UseUpdateOptions } from "@/hooks/queries";

import { useCreate, useUpdate } from "@/hooks/queries";

export const useCreateProject = (
  options?: UseCreateOptions<ProjectEntity, ProjectMutateVariables>
) => {
  return useCreate<ProjectEntity, ProjectMutateVariables>("projects", options);
};

export const useUpdateProject = (
  projectId: number,
  options?: UseUpdateOptions<ProjectEntity, ProjectMutateVariables>
) => {
  return useUpdate<ProjectEntity, ProjectMutateVariables>(
    "projects",
    projectId,
    options
  );
};
